import axios from "axios";
import { config } from "dotenv";

config()

const mode ={
    mode: 'no-cors'
}

/**
 * @param {*} userId is the userId of the user we want to search their profile
 * @param {*} email  is the email of the user we want to search their profile
 * @param {*} phone is the phone number of the user we want to search their profile
 * the precedence is userId => email => phone
 * @returns a promise such that when resolved it is an object of the userData
 * 
 * `searchUser(email="test123@gmail.com")` // `[{"id":"G5BTL0hUm7SU8E3pzR0MSzbkUQJ3","email":"test123@gmail.com","phone":""}]`
 * `searchUser(userId="G5BTL0hUm7SU8E3pzR0MSzbkUQJ3")` // `[{"id":"G5BTL0hUm7SU8E3pzR0MSzbkUQJ3","email":"test123@gmail.com","phone":""}]`
 */
export const searchUser = async (userId=null, email=null, phone=null) => {
    try {
        let url;
        if (userId){
            url = `${process.env.REACT_APP_API_URL}/searchPouchUsersbyId/?value=${userId}`
        } else if (email) {
            url = `${process.env.REACT_APP_API_URL}/searchPouchUsersbyEmail/?value=${email}`
        } else if (phone) {
            url = `${process.env.REACT_APP_API_URL}/searchPouchUsersbyPhone/?value=${phone}`
        }
        let response = (await axios.get(url, mode)).data
        // console.log(response)
        return response
    } catch (err) {
        return {
            message: err.message, status: false, code: 400
        }
    }
}